module.exports = __webpack_public_path__ + "static/media/14.c0cff526.jpg";